import rybbit from "@rybbit/js"
import { env } from "configs/EnvironmentConfig"
import posthog from "posthog-js"

/**
 * A function to track a page view.
 */
export function trackPageView(path: string) {
  // NOTE: This implementation is different than tracking of a regular event as both
  // analytics platforms offer a special interface for tracking page views. Posthog
  // has a special "$pageview" event name to distinguish it from a regular event.
  // Rybbit uses the `pageview` method to track page views.

  // send the information to posthog, if we have it enabled
  if (env.POSTHOG_KEY) {
    posthog.capture("$pageview", {
      path,
    })
  }

  // send the information to rybbit, if we have it enabled
  if (env.RYBBIT_SITE_ID) {
    rybbit.pageview(path)
  }
}
